import { useQuery } from '@tanstack/react-query';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { ClinicalNoteType, IClinicalNoteActivityEvent } from '../ClinicalNote';

export function useClinicalNoteActivityHistory(noteType: ClinicalNoteType, patientId?: string | number) {
    const id = patientId != null ? String(patientId) : undefined;
    return useQuery<IClinicalNoteActivityEvent[]>({
        queryKey: [QueryKeys.clinicalNoteActivity, noteType, id],
        queryFn: () => ClinicalNoteApi.getActivityHistory(id!, noteType),
        enabled: !!id,
    });
}
